import React, { createContext, useContext, useState } from 'react';

const UnresolvedLogsContext = createContext();

export const UnresolvedLogsProvider = ({ children }) => {
  const [hasUnresolvedLogs, setHasUnresolvedLogs] = useState(false);

  return (
    <UnresolvedLogsContext.Provider value={{ hasUnresolvedLogs, setHasUnresolvedLogs }}>
      {children}
    </UnresolvedLogsContext.Provider>
  );
};

export const useUnresolvedLogs = () => {
  const context = useContext(UnresolvedLogsContext);
  if (!context) {
    throw new Error('useUnresolvedLogs must be used within an UnresolvedLogsProvider');
  }
  return context;
}; 